// extracted by mini-css-extract-plugin
export var anchor = "AutolinkHeader-module--anchor--fHQ24";
export var cdsAssistiveText = "AutolinkHeader-module--cds--assistive-text--5-VtY";
export var cdsVisuallyHidden = "AutolinkHeader-module--cds--visually-hidden--9Cgne";
export var header = "AutolinkHeader-module--header--AdS6I";
export var hideFeedback = "AutolinkHeader-module--hide-feedback--Gcs4V";
export var leftAnchor = "AutolinkHeader-module--left-anchor--c2Dio";
export var rightAnchor = "AutolinkHeader-module--right-anchor--vFW4c";
export var showFeedback = "AutolinkHeader-module--show-feedback--LXG8y";
export var skeleton = "AutolinkHeader-module--skeleton--WXZf8";